import { useTranslation } from 'react-i18next';

import { LegalArticle, LegalSection } from './LegalArticle';

export function ImprintContent() {
  const { t } = useTranslation('legal');

  const sections = [
    {
      body: t(($) => $.imprint.provider.body),
      heading: t(($) => $.imprint.provider.heading),
    },
    {
      body: t(($) => $.imprint.register.body),
      heading: t(($) => $.imprint.register.heading),
    },
    {
      body: t(($) => $.imprint.contact.body),
      heading: t(($) => $.imprint.contact.heading),
    },
    {
      body: t(($) => $.imprint.representatives.body),
      heading: t(($) => $.imprint.representatives.heading),
    },
    {
      body: t(($) => $.imprint.vatId.body),
      heading: t(($) => $.imprint.vatId.heading),
    },
    {
      body: t(($) => $.imprint.office.body),
      heading: t(($) => $.imprint.office.heading),
    },
    {
      body: t(($) => $.imprint.responsible.body),
      heading: t(($) => $.imprint.responsible.heading),
    },
  ];

  return (
    <LegalArticle
      intro={t(($) => $.imprint.intro)}
      title={t(($) => $.imprint.title)}
    >
      <div className="flex flex-col gap-4">
        {sections.map((section) => (
          <LegalSection key={section.heading} heading={section.heading}>
            <p className="text-sm leading-relaxed break-words whitespace-pre-line text-gray-600">
              {section.body}
            </p>
          </LegalSection>
        ))}
      </div>
    </LegalArticle>
  );
}
